import React from 'react';
import legalConstants from '../constants/legal';

const localizedText = legalConstants['en-US'];

const Legal = () => (
  <div className='legal-container'>
    <h3>{localizedText.header}</h3>
    <p>
      <em>
        {localizedText.p1a_text} <a href={localizedText.program_desc_nav} target='_blank' rel='noopener noreferrer'>{localizedText.p1b_text}</a>
        {localizedText.p1c_text} <a href={`tel:${localizedText.program_desc_phone_nav}`}>{localizedText.program_desc_phone}</a>
        {localizedText.p1d_text} <a href={localizedText.my529_nav} target='_blank' rel='noopener noreferrer'>{localizedText.my529_text}</a>.
      </em>
    </p>
    <p>
      <strong>{localizedText.p2_head}</strong><em>{localizedText.p2_text}</em>
    </p>
    <p>
      <em>
        {localizedText.p3a_text}
        <a href={localizedText.fdic_nav} target='_blank' rel='noopener noreferrer'>{localizedText.p3b_text}</a>
        {localizedText.p3c_text}
      </em>
    </p>
    <p>
      <strong>{localizedText.p4_head}</strong><em>{localizedText.p4_text}</em>
    </p>
    <p>
      <strong>{localizedText.p5_head}</strong><em>{localizedText.p5_text}</em>
    </p>
    <p>
      <strong>{localizedText.p6_head}</strong>
      <em>
        {localizedText.p6a_text}
        <a href={localizedText.morningstar_nav} target='_blank' rel='noopener noreferrer'>{localizedText.morningstar_text}</a>
        {localizedText.p6b_text}
      </em>
    </p>
    <p>
      <em>{localizedText.p7_text}</em>
    </p>
  </div>
);

export { Legal };
